import { render, staticRenderFns } from "./caseteam.vue?vue&type=template&id=382c8084&scoped=true&"
import script from "./caseteam.vue?vue&type=script&lang=js&"
export * from "./caseteam.vue?vue&type=script&lang=js&"
import style0 from "./caseteam.vue?vue&type=style&index=0&id=382c8084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c8084",
  null
  
)

export default component.exports